import React, { FC } from 'react'
import { CheckmarkIcon } from './CheckmarkIcon'
import styles from './GreenCheckmark.module.scss'

export const GreenCheckmark: FC = () => (
  <div className={styles.GreenCheckmark}>
    <CheckmarkIcon />
  </div>
)
